import { UPDATE_BATCH_TYPE, UPDATE_CONVERSATION_VIEWER_SELECTED_ADJUSTER, UPDATE_FROM_ADJUSTER, UPDATE_TO_ADJUSTER } from "../action-types/adjusterActionType";

const initialState = {
    selectedAdjuster: null,
    fromAdjuster: null,
    toAdjuster: null,
    batchType: null
}

export const adjusterReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case UPDATE_CONVERSATION_VIEWER_SELECTED_ADJUSTER:
            return {
                ...state,
                selectedAdjuster: Object.assign(action.payload)
            }
        case UPDATE_TO_ADJUSTER:
            return {
                ...state,
                toAdjuster: action.payload
            }
        case UPDATE_FROM_ADJUSTER:
            return {
                ...state,
                fromAdjuster: action.payload
            }
        case UPDATE_BATCH_TYPE:
            return {
                ...state,
                batchType: action.payload
            }
        default:
            return state;
    }
}